export default __webpack_public_path__ + "static/media/ISSO CLASS-2 EXAM PATTERN 2025.f9b408b8.pdf";